import Box from '@mui/material/Box';
import { Component } from 'react';
import MenuAcessoRapido from './MenuAcessoRapido';

class TelaPrincipal extends Component {
    render() {
        return (
            <Box className="App">
                <MenuAcessoRapido />
            </Box>
        );
    }
}

export default TelaPrincipal;
